import { SceneId, ServerMessagePayload } from '@common/api';
import { SceneChangedEvent } from '@common/events';

import { ClientGlobalSystem } from './ClientBase';

/**
 * Detects when the local player's scene has changed and fires a SceneChangedEvent.
 */
export class SceneChangeDetectionSystem extends ClientGlobalSystem {
  private currentSceneId: SceneId | undefined;

  run(): ServerMessagePayload[] {
    const world = this.getWorld();
    const localPlayerService = this.clientServices.localPlayer;
    const playerId = localPlayerService.entityId;
    if (playerId === undefined) return [];

    const transform = world.getComponent(playerId, 'Transform');
    if (!transform || !transform.sceneId) return [];

    const newSceneId = transform.sceneId;

    // Check if scene has changed
    if (this.currentSceneId !== newSceneId) {
      const previousSceneId = this.currentSceneId;
      this.currentSceneId = newSceneId;

      // Only fire event when switching between scenes, not on initial load
      // (previousSceneId === undefined means this is the first scene assignment)
      if (previousSceneId !== undefined) {
        const event: SceneChangedEvent = {
          name: 'SceneChanged',
          source: 'SceneChangeDetectionSystem',
          payload: {
            previousSceneId,
            newSceneId,
          },
        };
        this.clientServices.common.eventBus.addEvent(event);
      }
    }

    return [];
  }
}
